import Add from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import React, { useCallback, useRef } from "react";
import { AssetAttrsDetails } from "../../interfaces/api";
import ExportMenu from "../Orion/ExportMenu";
import { useAddDocumentsAsset, useUpdateWorkflow } from "../Orion/OrionQueries";
import { useNotifications } from "../useNotifications";
import useSession from "../useSession/useSession";
import PageHeader from "./PageHeader";
import PageHeaderToolbar from "./PageHeaderToolbar";

function AssetPageToolbar({
  selectedTab,
  setSelectedTab,
  asset,
}: {
  selectedTab: number;
  setSelectedTab: Function;
  asset: AssetAttrsDetails | undefined;
}) {
  const { mutate: updateWorkflow } = useUpdateWorkflow();
  const notifications = useNotifications();
  const { data: session } = useSession();
  const {
    mutate: addDocuments,
    isSuccess: isDocSuccess,
    isError: isDocError,
  } = useAddDocumentsAsset();
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const uploadedFiles = Array.from(event.target.files || []);
    addDocuments({ assetId: asset!._id, files: uploadedFiles });
    if (isDocSuccess) {
      notifications.show("Document ajouté avec succès", {
        autoHideDuration: 3000,
        severity: "success",
      });
    } else if (isDocError) {
      notifications.show(
        "Une erreur est survenue lors de l'ajout du document",
        {
          autoHideDuration: 3000,
          severity: "success",
        }
      );
    }
  };

  const handleMenuClick = (event: SelectChangeEvent) => {
    updateWorkflow({
      processingId: asset!.processing!._id,
      assetId: asset!._id,
      workflow: event.target.value as string,
    });
  };
  if (!asset) return <PageHeaderToolbar />;
  else
    return (
      <PageHeaderToolbar>
        <Button
          onClick={() => fileInputRef.current && fileInputRef.current.click()}
        >
          <Add />
          Ajouter un document
        </Button>
        <ExportMenu
          assetIds={[asset!._id]}
          disabled={!asset.processing?.review}
        />
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleUpload}
          style={{ display: "none" }}
        />
        <ButtonGroup key="tabs">
          <Button
            onClick={() => setSelectedTab(0)}
            variant={selectedTab === 0 ? "contained" : "outlined"}
          >
            Mon Dossier
          </Button>
          <Button
            onClick={() => setSelectedTab(1)}
            variant={selectedTab === 1 ? "contained" : "outlined"}
            disabled={!asset?.processing?.review}
          >
            Mon Analyse
          </Button>
          {asset?.processing &&
            session?.OrionChatGroups.includes(asset.workspace_id) && ( // TODO asset.workspace id in OrionManagerGroups
              <Button
                onClick={() => setSelectedTab(2)}
                variant={selectedTab === 2 ? "contained" : "outlined"}
              >
                Chatbot
              </Button>
            )}
        </ButtonGroup>
        {asset?.processing && (
          <Select
            value={asset.processing.workflow as string}
            onChange={handleMenuClick}
            size="small"
          >
            {asset.processing.config.workflow.map((oneWorkflow) => (
              <MenuItem key={oneWorkflow.name} value={oneWorkflow.name}>
                {oneWorkflow.name}
              </MenuItem>
            ))}
          </Select>
        )}
      </PageHeaderToolbar>
    );
}

function AssetPageHeader({
  selectedTab,
  setSelectedTab,
  asset,
}: {
  selectedTab: number;
  setSelectedTab: Function;
  asset: AssetAttrsDetails | undefined;
}) {
  const PageToolbarComponent = useCallback(
    () => (
      <AssetPageToolbar
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        asset={asset}
      />
    ),
    [selectedTab, setSelectedTab, asset]
  );

  return (
    <PageHeader
      breadcrumbs={
        asset
          ? [
              { title: "Dossiers", path: "/orion/assets" },
              {
                title: asset.name || "",
                path: `/orion/asset/${asset._id}`,
              },
            ]
          : []
      }
      title={asset?.name || ""}
      slots={{ toolbar: PageToolbarComponent }}
    />
  );
}

export default AssetPageHeader;
